import { render, staticRenderFns } from "./bottom_1.vue?vue&type=template&id=391470fb&scoped=true"
import script from "./bottom_1.vue?vue&type=script&lang=js"
export * from "./bottom_1.vue?vue&type=script&lang=js"
import style0 from "./bottom_1.vue?vue&type=style&index=0&id=391470fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391470fb",
  null
  
)

export default component.exports